module.exports = __webpack_public_path__ + "static/media/loginBackGround.9f6204ae.png";